import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import { IPayout } from 'interfaces'
import { InfoBlock } from 'components'
import {
    getCountFractionDigits,
    getImageResizeSrc,
    priceFormat,
    numberFormat,
} from 'utils/helpers'
import style from './WalletPayoutCurrent.module.css'

type WalletPayoutCurrentPropType = {
    classes?: string
    data: IPayout
}

const WalletPayoutCurrent: React.FC<WalletPayoutCurrentPropType> = ({ classes, data }) => {
    const { currencyPlaceholderColor } = data

    const { t } = useTranslation()

    const amountSum = useMemo(() => {
        const {
            balanceAmount,
            currencyIsoCode,
            currencyShowCode,
            roundscale,
        } = data
        const fractionDigits = getCountFractionDigits(roundscale)
        const options = {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        }

        if (currencyIsoCode === 'KICKS_SESSIA') {
            return priceFormat(balanceAmount, { symbol: currencyShowCode, leftSymbolPlacement: false, isoCode: '' }, options)
        }

        return numberFormat(balanceAmount, { ...options, style: 'currency', currency: currencyIsoCode })
    }, [data])

    const bgImage = useMemo(() => {
        const { currencyIcon } = data
        return getImageResizeSrc({ src: currencyIcon, width: 700, quality: 90 })
    }, [data])

    return (
        <InfoBlock
            classes={cn(style.block, classes)}
            styles={{
                backgroundColor: currencyPlaceholderColor,
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <InfoBlock.Body classes={style.body}>
                <div className={style.amountSum}>
                    {amountSum}
                </div>
                <div className={style.amountDesc}>
                    {t('balance')}
                </div>
            </InfoBlock.Body>
        </InfoBlock>
    )
}

export default WalletPayoutCurrent
